import { Component, Input, OnChanges } from '@angular/core';
import { CalendarAccessStatus, CalendarConnectionStatus } from '@app/domain/one_to_one/model/calendar-connected.model';
import { IconHoverColor } from '@app/shared/components/inputs/table-action-icon/table-action-icon.component';
import { CommonMessages } from '@app/constants/common.messages';
import { Globals } from '@app/shared/globals/globals';
import { calendarNeedsAction } from '@app/shared/utils/calendar-access.utils';
import { SSO_RECONNECT_RETURN_URL } from '@app/shared/auth/sso-authorize';
import { OneToOneMessages } from '../../locale/one-to-one.messages';

// Tells the user on a page that uses their calendar that it can't be read, and links to Settings > Notifications to fix
// it: reconnect a calendar that lost access, or connect one when none is linked. Shown only when Settings offers that
// button, and on every visit until fixed (closing it hides it for this visit only).
@Component({
  selector: 'app-calendar-access-banner',
  templateUrl: './calendar-access-banner.component.html',
  styleUrls: ['./calendar-access-banner.component.scss']
})
export class CalendarAccessBannerComponent implements OnChanges {

  public readonly eIconHoverColor = IconHoverColor;
  public readonly eCommonMessages = CommonMessages;
  public readonly eCalendarAccessStatus = CalendarAccessStatus;
  public readonly eOneToOneMessages = OneToOneMessages;
  public readonly settingsUrl = SSO_RECONNECT_RETURN_URL;

  // The current user's calendar status, as the page already fetched it; nothing shows until it has arrived.
  @Input() calendarConnectionStatus: CalendarConnectionStatus;

  // Closed for this visit; it shows again next time the page opens.
  dismissed = false;

  constructor(private globals: Globals) {}

  // Why the banner shows (null: it doesn't), worked out once each time the status changes.
  reason: CalendarAccessStatus | null = null;

  ngOnChanges(): void {
    this.reason = calendarNeedsAction(this.calendarConnectionStatus, this.globals);
  }
}
